export default __webpack_public_path__ + "static/media/gallery-image-3.91c5f7ce.jpg";